import { Component, ElementRef, OnInit, ViewChild, QueryList, ViewChildren, Inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ShowsService } from '../services/shows.service';
import { environment } from "../../environments/environment";
import { Show } from "../interfaces/show.interface";
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { fromEvent, pipe } from 'rxjs';
import { ExcludeEmailComponent } from '../user-report/exclude-email/exclude-email.component';
import { debounceTime, distinctUntilChanged, tap } from "rxjs/operators";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../services/auth/auth.service';
import { CollaboratorsService } from '../services/collaborators.service';
import { Router } from '@angular/router';
import { UserService } from '../../app/services/user.service';



@Component({
  selector: 'app-likes',
  templateUrl: './likes.component.html',
  styleUrl: './likes.component.scss',
  standalone: false
})
export class LikesComponent implements OnInit {
  displayedColumns: string[] = ['show_code', 'custom_name', 'my_likes', 'total_user_likes', 'download_likes', 'download_user_likes', 'expand'];
  displayedColumns2: string[] = ['timestamp', 'my_likes', 'total_user_likes'];
  displayedColumns3: string[] = ['timestamp', 'my_likes'];
  dataSource = new MatTableDataSource();
  loading = false;
  loader = false;
  processing = false;
  expandedElement: any | null = null;
  total_reports = 0;
  no_subscription: any;
  subscription_plan: any;
  host_name = false;
  isAdmin = false;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('matSort1') sort1!: MatSort;
  @ViewChild('matSort2') sort2!: MatSort;
  @ViewChild('search') search!: ElementRef;
  sortList!: QueryList<MatSort>;
  @ViewChildren(MatSort) set matSort(ms: QueryList<MatSort>) {
    this.sortList = ms;
  }

  show: any;
  show_id: any;
  UUID: any;
  constructor(private router: Router,
    public showsService: ShowsService,
    public dialog: MatDialog,
    public auth: AuthService,
    public userService: UserService,
    public collaboratorsService: CollaboratorsService,
  ) {
    this.auth.token.subscribe((token: any) => {
      this.UUID = token.UUID;
      
    });
    	this.auth.isAdmin.subscribe((status: any) => {
			this.isAdmin = status;

        });
    this.userService.checkSubscriptionPlanStatus().subscribe((response: any) => {
      this.no_subscription = response.error;
      this.subscription_plan = response.subscription.subscription_plan;
      console.log('subscription_plan', this.subscription_plan);
      this.loader = true;
    });
  }

  ngOnInit(): void {
    if (window.location.hostname == environment.igniteDomain) {
      this.host_name = true;
    }
    this.getReport();
  }

  ngAfterViewInit() {
    this.paginator._intl.itemsPerPageLabel = "Shows per page:";
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort1;
    fromEvent(this.search.nativeElement, 'keyup')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0;
        })
      )
  }



  getReport() {
    this.loading = true;
    this.showsService.myLikes().subscribe((response: any) => {
      this.dataSource = new MatTableDataSource(response.map((data: any) => ({
        ...data,
        childData: new MatTableDataSource()
      })));
      this.loader = true
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort1;
      this.total_reports = this.dataSource.filteredData.length;
      this.loading = false;
    });
  }

  toggleRow(element: any, i: number) {
    console.log(i)
    this.expandedElement = this.expandedElement === element ? null : element;
    if (this.expandedElement) {
      element.childData = new MatTableDataSource();
      this.loadChildren(element, i);
    }
  }

  loadChildren(element: any, i: number, download = false, userLikes = false) {
    this.showsService.myLikesDetails(element.show_code).subscribe((response: any) => {
      element.childData = new MatTableDataSource(response);
      element.childData.sort = this.sortList.toArray()[i + 1];
      console.log(this.sortList.toArray())
      console.log(i)
      if (download) {
        this.downloadCSV(element, userLikes)
      }
      // element.childData.map((data: any) => {
      //   data.show_date = new Date(data.show_date.split(' ')[0]);
      // });
    });
  }

  downloadLikes(element: any, i: number) {
    if (element.childData.data.length == 0) {
      this.loadChildren(element, i, true);
    }
    else {
      this.downloadCSV(element, false)
    }
  }
  downloadUserLikes(element: any, i: number) {
    if (element.childData.data.length == 0) {
      this.loadChildren(element, i, true, true);
    }
    else {
      this.downloadCSV(element, true)
    }
  }
  downloadCSV(element: any, userLikes: boolean) {
    const recordsToDownload = element.childData.data.map((data: any) => {
      return [
        element.hasFireworks ? data.firework_name :
          this.convertTime(data.timestamp),
        // element.custom_name,
        userLikes ? data.total_user_likes : data.my_likes
      ]
    });

    const csvOptions = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: false,
      title: (userLikes ? 'My Likes: ' : 'Total User Likes') + element.show_code,
      useTextFile: false,
      useBom: true,
      headers: [element.hasFireworks ? "Firework Name" : "Event Time", userLikes ? "Total User Likes" : "My Likes"]
    };

    new AngularCsv(recordsToDownload, (userLikes ? 'Total-User-Likes-' : 'My-Likes-') + element.show_code, csvOptions);
  }

  convertTime(seconds: number) {
    let s = seconds % 60
    let minutes = (seconds - s) / 60
    s = Math.round(s);
    let m = minutes % 60
    let h = (minutes - m) / 60
    return (h > 0 ? h + "h " : "") + m + "m " + s + "s"
  }
  goToSubscription() {
    this.router.navigate(['/subscription']);
    //  this.dialog.close(false);
  }
}
